// Holding Costs spec 1.3: pill 113x26 rx6 #EEF3EC, selected chip rx5 white with no shadow (v3),
// labels 13/600, selected #4AA52A. Only "Monthly selected" is drawn; the "Total selected" chip is
// derived -- see README.md ("Monthly | Total toggle").
const PILL_CLS = 'relative w-[113px] h-[26px] rounded-[6px] bg-[#EEF3EC] hover:bg-[#DDE9D8] shrink-0'
const CHIP_BASE = 'absolute top-[1px] h-[24px] rounded-[5px] bg-white transition-[left,width]'
const LABEL_BASE =
  'relative z-10 h-[24px] mt-[1px] text-[13px] font-semibold text-center leading-[24px] rounded-[5px] outline-none focus-visible:ring-2 focus-visible:ring-brand-green'
const MONTHLY_W = 65
const TOTAL_W = 46

// `value` is the stored toggle string: the formula core reads only the literal 'Total'
// (reilm-be flip/holdingCosts.js), so anything else -- unset included -- is Monthly.
export default function MonthlyTotalToggle({ value, onChange, ariaLabel }) {
  const isTotal = value === 'Total'

  return (
    <div className={PILL_CLS} role="radiogroup" aria-label={ariaLabel}>
      <div
        className={CHIP_BASE}
        style={isTotal ? { left: 1 + MONTHLY_W, width: TOTAL_W } : { left: 1, width: MONTHLY_W }}
      />
      <div className="relative flex pl-[1px]">
        <button
          type="button"
          role="radio"
          tabIndex={-1}
          aria-checked={!isTotal}
          onClick={() => onChange('Monthly')}
          className={`${LABEL_BASE} w-[65px] ${!isTotal ? 'text-[#4AA52A]' : 'text-brand-dark'}`}
        >
          Monthly
        </button>
        <button
          type="button"
          role="radio"
          tabIndex={-1}
          aria-checked={isTotal}
          onClick={() => onChange('Total')}
          className={`${LABEL_BASE} w-[46px] ${isTotal ? 'text-[#4AA52A]' : 'text-brand-dark'}`}
        >
          Total
        </button>
      </div>
    </div>
  )
}
